module.exports = __webpack_public_path__ + "static/media/completed.7b1c54a3.svg";